import { BranchLayer, ElectorateLayer, OldBranchesLayer, RegionalCouncilLayer } from '@shared/consts';
import { $id } from './helpers';
export function displayResults(data) {
    if (!data)
        return;
    // Get UI elements
    const results = $id('results');
    const emptyState = $id('empty-state');
    const errorState = $id('error-state');
    const branchName = $id('branch-name');
    const oldBranchName = $id('old-branch-name');
    const electorateName = $id('electorate-name');
    const councilName = $id('council-name');
    // Hide loading/empty/error states
    hideLoading();
    if (emptyState)
        emptyState.hidden = true;
    if (errorState)
        errorState.hidden = true;
    // Check if we have features
    if (Object.keys(data).length === 0) {
        showError('No location data found for this area.');
        return;
    }
    // Extract properties from layers
    const branchData = data[BranchLayer];
    const oldBranchData = data[OldBranchesLayer];
    const electorateData = data[ElectorateLayer];
    const councilData = data[RegionalCouncilLayer];
    /* Data needed:
      - Branch  →  BranchLayer
      - Province  →  BranchLayer
      - Electorate  →  ElectorateLayer
  
      - Māori Branch  →  N/A
      - Māori Electorate  →  N/A
      - Local Boundaries  →  RegionalCouncilLayer?
  
      - Pre-2025 Branch  →  OldBranchesLayer
      - Pre-2025 Electorate  →  N/A
    */
    // TODO: Add the things automatically
    // Clear results
    // if (results) results.innerHTML = '';
    if (branchName) {
        const bProps = branchData?.features[0]?.properties || {};
        branchName.textContent = bProps.gbranch || bProps.name || 'Unknown';
    }
    if (oldBranchName) {
        const obProps = oldBranchData?.features[0]?.properties || {};
        oldBranchName.textContent = obProps.gbranch || obProps.name || 'Unknown';
    }
    if (electorateName) {
        const eProps = electorateData?.features[0]?.properties || {};
        electorateName.textContent = eProps.name || 'Unknown';
    }
    if (councilName) {
        const cProps = councilData?.features[0]?.properties || {};
        councilName.textContent = cProps.name || 'Unknown';
    }
    if (results)
        results.hidden = false;
}
// function 
export function showLoading() {
    const loading = $id('loading');
    const emptyState = $id('empty-state');
    const results = $id('results');
    const errorState = $id('error-state');
    if (loading)
        loading.hidden = false;
    if (emptyState)
        emptyState.hidden = true;
    if (results)
        results.hidden = true;
    if (errorState)
        errorState.hidden = true;
}
export function hideLoading() {
    const loading = $id('loading');
    if (loading)
        loading.hidden = true;
}
export function showError(message) {
    const errorState = $id('error-state');
    const errorMessage = $id('error-message');
    const emptyState = $id('empty-state');
    const results = $id('results');
    if (errorState)
        errorState.hidden = false;
    if (errorMessage)
        errorMessage.textContent = message;
    if (emptyState)
        emptyState.hidden = true;
    if (results)
        results.hidden = true;
}
